module.exports = __webpack_public_path__ + "img/podcast_image_svg.dccdf339.svg";